import { render, staticRenderFns } from "./MainComponent.vue?vue&type=template&id=4491ac0a"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4491ac0a')) {
      api.createRecord('4491ac0a', component.options)
    } else {
      api.reload('4491ac0a', component.options)
    }
    module.hot.accept("./MainComponent.vue?vue&type=template&id=4491ac0a", function () {
      api.rerender('4491ac0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/MainComponent.vue"
export default component.exports